import React, { useEffect } from 'react';
import styled from 'styled-components';
import { MdClose } from 'react-icons/md';
import {
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    CloseButton
} from './ModalParts';

const StandardModal = ({
    isOpen,
    onClose,
    title,
    children,
    footer,
    width,
    closeOnOverlayClick = true
}) => {
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') onClose();
        };
        if (isOpen) {
            document.addEventListener('keydown', handleEsc);
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.removeEventListener('keydown', handleEsc);
            document.body.style.overflow = 'auto';
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <ModalOverlay onClick={closeOnOverlayClick ? onClose : undefined}>
            <ModalContent onClick={(e) => e.stopPropagation()} $width={width}>
                <ModalHeader>
                    <ModalTitle>{title}</ModalTitle>
                    <CloseButton onClick={onClose} aria-label="Close modal">
                        <MdClose />
                    </CloseButton>
                </ModalHeader>
                <ModalBody>
                    {children}
                </ModalBody>
                {footer && (
                    <ModalFooter>
                        {footer}
                    </ModalFooter>
                )}
            </ModalContent>
        </ModalOverlay>
    );
};

export default StandardModal;
